
import React, { useEffect, useState, Children, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link } from "react-router-dom"
import Button from '../formfields/Button'

type Props = {
  isExpanded: boolean
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>
  bgcolor?: string
  textcolor?: string
  size?: 'small' | 'medium' | 'large'
}


function ExpandCollapseIcon({
  isExpanded,
  setIsExpanded,
  bgcolor = `bg-gray-300`,
  textcolor = `text-brandblue`,
  size = 'medium'
}: Props) {




  return <div
    className={`
      ${size === 'small' ? ' p-3 text-xl max-w-4 max-h-4 ' : ''}
      ${size === 'medium' ? ' p-4 text-2xl max-w-6 max-h-6 ' : ''}
      ${size === 'large' ? ' p-5 text-3xl max-w-8 max-h-8 ' : ''}
      ${bgcolor} ${textcolor} hover:opacity-80 cursor-pointer rounded-full flex items-center justify-center font-righteous
    ${isExpanded ? ' rotate-90 ' : ''}
    `}
    onClick={() => setIsExpanded(!isExpanded)}>
    &gt;
  </div>
}

export default ExpandCollapseIcon